module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, _vm._l((_vm.territories), function(terr) {
    return _c('territory', {
      key: terr.id,
      attrs: {
        "id": terr.id,
        "reserves": terr.reserves,
        "icon": _vm.codes[terr.owner]
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a112fcb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/board.vue
// module id = 193
// module chunks = 0